<script>
import { Pie } from "vue-chartjs";

export default {
    extends: Pie,
    props: {
        dataPieChart  : { type: [Object,Array], default: []    },
        colorScheme : { type: [Object,Array], default: []    },
        reload : { type : [String,Array,Number,Boolean], default: ""},
    },
    data () {
        return{
            labelChart:[],
            dataChart:[],
        }
    },
    watch:{
        reload(){
            this.reloadChart();
        }
    },
    methods:{
        renderPieChart(){
            this.renderChart(
                {
                  labels: this.labelChart,
                  datasets: [
                    {
                      backgroundColor: this.colorScheme,
                      data: this.dataChart,
                    }
                  ]
                },
                {   
                    responsive: true,
                    maintainAspectRatio: false,
                    legend:{
                        labels: {
                            boxWidth: 20,
                            padding:20,
                        },
                        position: "bottom",
                    },
                    animation: {
                      duration: 2000,
                      easing: "easeInOutQuart",

                    },
                }
            );
        },
        reloadChart(){
            this.labelChart = []
            this.dataChart = []
            this.dataPieChart.forEach((element)=>{
                if (element.total > 0){
                    this.labelChart.push(element.label)
                    this.dataChart.push(element.total)
                }
            })
            this.renderPieChart()
        },
            
    },
    created(){
        // this.reloadChart();
    }
};
</script>